import { DivisiResponse } from "../../../../models/Divisi";
import { PertanyaanResponse } from "../../../../models/Pertanyaan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import ApiClient from "../../../apiClient";

export async function pertanyaan(
  PERTANYAAN_ID: number
): Promise<PertanyaanResponse> {
  const res = await ApiClient.get(
    `/Pertanyaan?PERTANYAAN_ID=${PERTANYAAN_ID}`
  );
  return res.data[0];
}

export const useFetchPertanyaan = mutationWrapper(pertanyaan);
